import React, { useState } from 'react';
import { useI18n } from '@hydra/common/components/i18n';
import Icon from '@hydra/common/components/Icon';
import MenuItem from '@hydra/common/components/MenuItem';
import settings from '@hydra/utils/settings';

import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  languages: {
    fontSize: theme.typography.fontSizeBase
  },
  language: {
    fontSize: theme.typography.fontSizeSmall,
    fontWeight: theme.typography.fontWeightBold
  }
}));

export function LanguageSwitcher (props) {
  const classes = useStyles();
  const { locale, languageLabels, pathname } = useI18n();
  const { languages } = settings.get('translations');

  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick (event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose () {
    setAnchorEl(null);
  }

  const languageMenuItems = languages
    .filter(language => language !== locale)
    .map((language, index) => {
      const newPathname = pathname.replace(/^\/\S\S\//, `/${language}/`);
      return (
        <MenuItem key={index} onClick={handleClose} component={ButtonBase} href={newPathname}>
          <Typography noWrap component='div'>
            <div className={classes.languages}>
              {languageLabels[language]}
            </div>
          </Typography>
        </MenuItem>
      );
    });

  const type = anchorEl ? 'chevron-up' : 'chevron-down';

  return (
    <div id='nav-languages'>
      <ButtonBase onClick={handleClick}>
        <Typography noWrap component='div'>
          <div className={classes.language}>
            {languageLabels[locale]}
          </div>
        </Typography>
        <Icon size='md' color='grey' type={type} />
      </ButtonBase>
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuList disablePadding>
          {languageMenuItems}
        </MenuList>
      </Menu>
    </div>
  );
}

export default LanguageSwitcher;
